<template>
    <page :showBackButton="true">
        <base-select
            v-model="businessCase"
            id="businessCase"
            label="Finanzierungsantrag"
        >
            <ion-select-option
                :value="key"
                v-for="(value, key, index) in checklists"
                :key="key"
                v-bind:selected="index === 0"
                >{{ value["description"] }} |
                {{ value["date"] }}</ion-select-option
            >
        </base-select>

        <template v-if="Object.keys(selectedBusinessCase).length">
            <ion-grid class="ion-margin-vertical">
                <ion-row class="c-statusbar">
                    <ion-col size="3">
                        <div
                            class="c-statusbar__element -open"
                            :class="{ '-selected': statusbar.open.selected }"
                            @click="selectStatus('open')"
                        >
                            {{ statusCount.open }}
                            <span class="icon-open"></span>
                        </div>
                    </ion-col>
                    <ion-col size="3">
                        <div
                            class="c-statusbar__element -uploaded"
                            :class="{
                                '-selected': statusbar.uploaded.selected,
                            }"
                            @click="selectStatus('uploaded')"
                        >
                            {{ statusCount.uploaded }}
                            <span class="icon-uploaded"></span>
                        </div>
                    </ion-col>
                    <ion-col size="3">
                        <div
                            class="c-statusbar__element -rejected"
                            :class="{
                                '-selected': statusbar.rejected.selected,
                            }"
                            @click="selectStatus('rejected')"
                        >
                            {{ statusCount.rejected }}
                            <span class="icon-rejected"></span>
                        </div>
                    </ion-col>
                    <ion-col size="3">
                        <div
                            class="c-statusbar__element -approved"
                            :class="{
                                '-selected': statusbar.approved.selected,
                            }"
                            @click="selectStatus('approved')"
                        >
                            {{ statusCount.approved }}
                            <span class="icon-approved"></span>
                        </div>
                    </ion-col>
                </ion-row>

                <ion-row class="ion-text-center u-size-small">
                    <ion-col size="3">
                        Ausständig
                    </ion-col>
                    <ion-col size="3">
                        Hinzugefügt
                    </ion-col>
                    <ion-col size="3">
                        Abgelehnt
                    </ion-col>
                    <ion-col size="3">
                        Akzeptiert
                    </ion-col>
                </ion-row>
            </ion-grid>

            <h1>
                {{ selectedBusinessCase.description }} |
                {{ selectedBusinessCase.date }}
            </h1>

            <h2>{{ checklist.title }}</h2>

            <div v-if="!anyItems">
                Keine Daten vorhanden. Bitte überprüfe deine eingestellten
                Filter.
            </div>
            <template v-for="(group, groupkey) in filteredGroups">
                <div
                    class="u-m-top-large"
                    :key="groupkey"
                    v-if="Object.keys(group.items).length > 0"
                >
                    <h3 class="ion-margin-top">{{ group.title }}</h3>

                    <template v-for="(items, itemskey) in group.items">
                        <div
                            :key="itemskey"
                            class="c-expansion-card-container"
                            :class="'-' + items.status.toLowerCase()"
                        >
                            <expansion-card class="c-expansion-card">
                                <template v-slot:header>
                                    <h5 class="ion-no-margin">
                                        {{ items.title }}
                                    </h5>
                                    <span v-if="!items.updateallowed"
                                        >wird von Berater hochgeladen</span
                                    >
                                </template>

                                <div class="ion-margin-bottom">
                                    {{ items.description }}
                                </div>

                                <ion-list
                                    v-if="
                                        Object.keys(items.documents).length > 0
                                    "
                                >
                                    <template
                                        v-for="(document,
                                        documentkey) in items.documents"
                                    >
                                        <ion-item :key="documentkey">
                                            <ion-label class="ion-text-wrap">
                                                <a
                                                    @click.prevent="
                                                        downloadFile(
                                                            baseurl +
                                                                '/servlets/klickmal/api/?Mode=MeinServicebereich&Function=GetCheckListDocument&DocumentId=' +
                                                                documentkey
                                                        )
                                                    "
                                                >
                                                    {{ document.description }}
                                                </a>
                                            </ion-label>
                                            <ion-button
                                                fill="clear"
                                                color="danger"
                                                class="c-expansion-card__delete"
                                                v-on:click="
                                                    deleteDokument(documentkey)
                                                "
                                                v-if="
                                                    items.status !==
                                                        'APPROVED' &&
                                                    items.updateallowed
                                                "
                                            >
                                                <span
                                                    class="icon-entfernen"
                                                    slot="end"
                                                ></span>
                                            </ion-button>
                                        </ion-item>
                                    </template>
                                </ion-list>

                                <template
                                    v-if="
                                        items.status !== 'APPROVED' &&
                                        items.updateallowed
                                    "
                                >
                                    <ion-button
                                        expand="block"
                                        class="ion-margin-top"
                                        fill="outline"
                                        color="dark"
                                        v-on:click="
                                            openKreditchecklisteUploadModal(
                                                itemskey
                                            )
                                        "
                                    >
                                        <span
                                            class="icon-hochladen ion-margin-end"
                                            slot="start"
                                            style="font-size: x-large;"
                                        ></span>
                                        <ion-label
                                            >Dokument hinzufügen</ion-label
                                        >
                                    </ion-button>
                                </template>
                            </expansion-card>
                        </div>
                    </template>
                </div>
            </template>
        </template>
    </page>
</template>

<script>
import Page from "@/components/Page";
import BaseSelect from "@/components/BaseSelect";
import ExpansionCard from "@/components/ExpansionCard";
import KreditchecklisteUploadModal from "@/components/KreditchecklisteUploadModal";
import { BASEURL } from "@/utils/globals";
import { Plugins } from "@capacitor/core";
import { file } from "@/mixins/file";

import { deleteChecklist } from "@/api/kreditcheckliste";

export default {
    mixins: [file],
    components: { Page, BaseSelect, ExpansionCard },
    props: {
        checklistKey: {
            required: false,
            type: String,
            default: "",
        },
    },
    data() {
        return {
            baseurl: BASEURL,
            Browser: Plugins.Browser,
            businessCase: "",
            statusbar: {
                open: {
                    selected: false,
                },
                uploaded: {
                    selected: false,
                },
                rejected: {
                    selected: false,
                },
                approved: {
                    selected: false,
                },
            },
            anyItems: false,
        };
    },
    mounted() {
        this.fillData();
        this.$store.commit("setLoadingSpinnerDuration", 60 * 1000);
        this.$store
            .dispatch("kreditcheckliste/getChecklistsEntries")
            .then(() => {
                this.fillData();
                this.$store.commit("setLoadingSpinnerDuration", 20 * 1000);
            });
    },
    computed: {
        checklists() {
            return this.$store.state.kreditcheckliste.all;
        },
        selectedBusinessCase() {
            let result = {};
            if (this.businessCase in this.checklists) {
                result = this.checklists[this.businessCase];
            }
            return result;
        },
        checklist() {
            let result = {};
            if ("checklist" in this.selectedBusinessCase) {
                result = this.selectedBusinessCase.checklist;
            }
            return result;
        },
        filteredGroups() {
            let result = {};
            let isFilterSelected = false;
            // eslint-disable-next-line
            this.anyItems = false;
            for (let key in this.statusbar) {
                if (this.statusbar[key].selected) {
                    isFilterSelected = true;
                    break;
                }
            }
            if (isFilterSelected) {
                for (let groupKey in this.checklist.groups) {
                    let group = this.checklist.groups[groupKey];
                    result[groupKey] = {};
                    result[groupKey].description = group.description;
                    result[groupKey].title = group.title;
                    result[groupKey].items = {};
                    for (let itemKey in group.items) {
                        let item = group.items[itemKey];
                        let itemStatus = String(item.status).toLowerCase();
                        if (this.statusbar[itemStatus].selected) {
                            result[groupKey].items[itemKey] = item;
                            // eslint-disable-next-line
                            this.anyItems = true;
                        }
                    }
                }
            } else {
                result = this.checklist.groups;
                // eslint-disable-next-line
                this.anyItems = true;
            }
            return result;
        },
        statusCount() {
            let result = { open: 0, uploaded: 0, rejected: 0, approved: 0 };

            for (let group in this.checklist.groups) {
                for (let item in this.checklist.groups[group].items) {
                    switch (
                        this.checklist.groups[group].items[
                            item
                        ].status.toLowerCase()
                    ) {
                        case "open":
                            result.open++;
                            break;
                        case "uploaded":
                            result.uploaded++;
                            break;
                        case "rejected":
                            result.rejected++;
                            break;
                        case "approved":
                            result.approved++;
                            break;
                    }
                }
            }

            return result;
        },
    },
    methods: {
        selectStatus(status) {
            for (let statusKey in this.statusbar) {
                if (statusKey === status) {
                    this.statusbar[statusKey].selected = !this.statusbar[
                        statusKey
                    ].selected;
                } else {
                    this.statusbar[statusKey].selected = false;
                }
            }
        },
        fillData() {
            if (
                Object.keys(this.$store.state.kreditcheckliste.all).length > 0
            ) {
                if (
                    this.$store.state.kreditcheckliste.all.hasOwnProperty(
                        this.checklistKey
                    )
                ) {
                    this.businessCase = this.checklistKey;
                } else {
                    this.businessCase = Object.keys(
                        this.$store.state.kreditcheckliste.all
                    )[0];
                }
            }
        },
        openKreditchecklisteUploadModal(checklistItemId) {
            // console.log(checklistItemId);
            this.$ionic.modalController
                .create({
                    component: KreditchecklisteUploadModal,
                    componentProps: {
                        propsData: { checklistItemId: checklistItemId },
                        parent: this,
                    },
                })
                .then((m) => m.present());
        },
        deleteDokument(documentId) {
            // console.log(documentId);
            this.$ionic.alertController
                .create({
                    header: "Dokument löschen",
                    message: "Möchtest du dieses Dokument wirklich löschen?",
                    buttons: [
                        {
                            text: "Abbrechen",
                            role: "cancel",
                        },
                        {
                            text: "Durchführen",
                            handler: () => {
                                this.deleteChecklist(documentId);
                            },
                        },
                    ],
                })
                .then((a) => a.present());
        },
        deleteChecklist(documentId) {
            this.$store.commit("setLoading", true);
            deleteChecklist(documentId).then((response) => {
                if (response.data.Status === 200) {
                    if (response.data.Result.Deleted == "Ok") {
                        this.$store.dispatch(
                            "kreditcheckliste/getChecklistsEntries"
                        );
                        this.$ionic.alertController
                            .create({
                                header: "Dokument wurde erfolgreich gelöscht",
                                // message: "Möchtest du dieses Dokument wirklich löschen?",
                                buttons: [
                                    {
                                        text: "Ok",
                                        role: "cancel",
                                    },
                                ],
                            })
                            .then((a) => a.present());
                    }
                }
            });
        },
    },
};
</script>

<style lang="scss" scoped>
.c-kreditcheckliste {
    &__download {
        cursor: pointer;
    }
}
.c-expansion-card {
    // padding: 0;

    a {
        color: var(--ion-color-dark);
    }
    &__delete {
        font-size: large;
        font-weight: bold;
    }

    ion-list {
        padding: var(--gangl-padding-medium);
        border-radius: var(--gangl-border-radius);
    }

    // &.-open {
    //   background-color: var(--ion-color-medium);
    // }
    // &.-uploaded {
    //   background-color: var(--ion-color-warning);
    // }
    // &.-rejected {
    //   background-color: var(--ion-color-danger);
    // }
    // &.-approved {
    //   background-color: var(--ion-color-success);
    // }
}

.c-expansion-card-container {
    &.-open .c-expansion-card {
        background-color: var(--ion-color-medium);
    }
    &.-uploaded .c-expansion-card {
        background-color: var(--ion-color-warning);
    }
    &.-rejected .c-expansion-card {
        background-color: var(--ion-color-danger);
    }
    &.-approved .c-expansion-card {
        background-color: var(--ion-color-success);
    }
}
.c-statusbar {
    // background: red;
    text-align: center;
    position: relative;

    &:before {
        content: "";
        display: inline-block;
        position: absolute;
        top: 50%;

        width: 100%;
        border-top: dashed 2px var(--ion-color-medium);
    }
    &__element {
        text-align: center;
        padding: 15px;
        border: solid 2px var(--ion-color-medium);
        border-radius: 100px;
        background-color: var(--ion-color-dark-contrast);
        display: inline-block;
        line-height: 1;
        color: var(--ion-color-light-contrast);
        // position: relative;
        cursor: pointer;

        &.-selected {
            border-width: 5px;
            padding: 12px;
            background-color: var(--ion-color-light);
        }

        &.-open {
            border-color: var(--ion-color-medium);
        }
        &.-uploaded {
            border-color: var(--ion-color-warning);
        }
        &.-rejected {
            border-color: var(--ion-color-danger);
        }
        &.-approved {
            border-color: var(--ion-color-success);
        }
    }
}
</style>
